//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import Fuse from 'fuse.js';

import { isDefined } from '@utils/filterPredicates';

const DEFAULT_FUZZY_SEARCH_THRESHOLD = 0.3;

interface IFuzzySearchConfig<T> {
  isCaseSensitive?: boolean;
  itemsToSearch: T[];
  searchKeys: string[];
  searchTerm: string;
  threshold?: number;
}

export const getFuzzySearch = <T>({
  isCaseSensitive,
  itemsToSearch,
  searchKeys,
  searchTerm,
  threshold = DEFAULT_FUZZY_SEARCH_THRESHOLD,
}: IFuzzySearchConfig<T>): T[] => {
  if (!isDefined(itemsToSearch)) return [];

  // Create a copy of the itemsToSearch array to prevent mutations
  const itemsCopy = [...itemsToSearch];

  const fuse = new Fuse(itemsCopy, {
    keys: searchKeys,
    isCaseSensitive,
    threshold,
  });

  return fuse.search(searchTerm).map((result) => result.item);
};
